<!--<c-header class="mb-4 d-print-none" position="sticky">-->
<ng-container class="h-5">
  <c-container
    [fluid]="true"
    [ngStyle]="{
      'border-bottom': isDarkTheme ? '1px solid #464646' : '1px solid #d3d3d3'
    }"
    class="px-4"
  >
    <button
      [cSidebarToggle]="sidebarId"
      cHeaderToggler
      class="btn"
      toggle="visible"
      style="margin-inline-start: -14px; color: {{
        isDarkTheme ? 'white' : 'black'
      }}"
    >
      <svg cIcon name="cilMenu" size="normal"></svg>
    </button>
    <c-header-nav class="d-none d-md-flex">
      <c-nav-item>
        <a
          cNavLink
          routerLink="/dashboard"
          class="fs-08"
          routerLinkActive="active"
          >Dashboard</a
        >
      </c-nav-item>
    </c-header-nav>

    <c-header-nav class="justify-end d-flex ms-auto">
      <div class="tooltip-container">
        <a cNavLink (click)="openFeedbackModal()">
          <svg cIcon class="my-1" name="cilStar" size="normal"></svg>
          <span class="tooltip-text">Rate us</span>
        </a>
      </div>
      
      <div>
        <div class="tooltip-container">
          <a cNavLink (click)="toggleDropdown()" class="relative inline-block" class="animate__animated animate__bounce animate__repeat-2">
          
            <svg cIcon class="my-1" name="cilBell" size="normal"></svg>
            <span
              class="absolute top-2 right-0 transform translate-x-1/4 -translate-y-1/4 bg-red-500 text-white text-xs font-normal rounded-full px-1.5 py-0.5"
            >
              {{ unreadNotificationsLength }}
            </span>
          </a>
          <ul
          class="dropdown-menu dropdown-notification pt-2 overflow-y-auto rounded-md border-[1px] border-solid"
          [ngClass]="{
            'dropdown-dark-theme': currentTheme === 'dark',
            'dropdown-light-theme': currentTheme === 'light',
            'show': dropdownOpen
          }"
        >
            <div class="d-flex justify-center items-center">
              <span class="font-bold text-base"> Notifications </span>
              <span
                class="text-end w-full mt-2 absolute right-[1.5rem] top-0"
                (click)="toggleDropdown()"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-circle-x"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="m15 9-6 6" />
                  <path d="m9 9 6 6" /></svg
              ></span>
            </div>
            <ng-container
              *ngIf="getUnreadNotifications().length > 0; else noNotifications"
            >
              <ul
              class="py-2 px-2 my-1 rounded-md cursor-pointer"
              >
              <li
              class="custom-boxshadow min-h-[10vh] flex justify-center items-center rounded-md cursor-pointer"
              [ngClass]="{
                'notification-item-dark-theme': currentTheme === 'dark',
                'notification-item-light-theme': currentTheme === 'light'
              }"
              *ngFor="let notification of getUnreadNotifications()"
            >
                <div class="font-normal mr-4 d-flex w-100 justify-between">
                  <div class="d-flex items-center">
                    <span class="px-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-person-circle"
                        viewBox="0 0 16 16"
                      >
                        <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                        <path
                          fill-rule="evenodd"
                          d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"
                        />
                      </svg>
                    </span>
                    <span
                      (click)="patchNotifications(notification)"
                      [ngClass]="{
                        'font-normal': notification.read_ind === 'Y',
                        'font-[500] text-[0.65rem]':
                          notification.read_ind === 'N'
                      }"
                    >
                      {{ notification.message }}
                    </span>
                    <a
                    *ngIf="notification.actionLink"
                    (click)="navigateToLink(notification.actionLink)"
                    class="text-[0.65rem]"
                  >View File</a>
                  
                  </div>
                  <span class="px-3 p-[15px]">
                    <svg
                    (click)="removeNotification(notification)"
                    class="bi bi-trash remove-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                      <path
                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"
                      />
                      <path
                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"
                      />
                    </svg>
                  </span>
                </div>
              </li>
              </ul>
              <li
                class="viewAll flex justify-center items-center py-3 px-2 my-1 rounded-lg shadow-md w-[100%] absolute bottom-0"
              [style.background-color]='currentTheme === "dark" ? "#2a303d" : "white"'
            [style.color]='currentTheme === "dark" ? "#ffffff" : "black"'
              >
                <a
                  (click)="toggleDropdown()"
                  class="w-full text-center text-blue-500 font-semibold text-[0.65rem]"
                  routerLink="/notifications"
                  >View All</a
                >
              </li>
            </ng-container>
            <!-- <ng-container *ngIf="getUnreadNotifications().length > 0; else noNotifications">
					<li class="flex justify-center items-center py-3 px-2 my-1 bg-white rounded-lg shadow-md" *ngFor="let notification of getUnreadNotifications()" style="box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;">
					  <div class="font-semibold mr-4 d-flex w-100 justify-between">
						<div class="d-flex items-center">
						  <span class="px-3">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-circle" viewBox="0 0 16 16">
							  <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
							  <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"/>
							</svg>
						  </span>
						  <span (click)="patchNotifications(notification)" [ngClass]="{'font-normal': notification.read_ind === 'Y', 'font-semibold': notification.read_ind === 'N'}">
							{{ notification.message }}
						  </span>
						  <a *ngIf="notification.actionLink" [href]="notification.actionLink">View File</a>
						</div>
						<span class="px-3">
						  <svg (click)="removeNotification(notification)" style="color:red" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
							<path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
							<path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
						  </svg>
						</span>
					  </div>
					</li>
					<li class="flex justify-center items-center py-3 px-2 my-1 bg-white rounded-lg shadow-md" style="box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;">
					  <a (click)="toggleDropdown()" class="w-full text-center text-blue-500 font-semibold" routerLink="/notifications">View All</a>
					</li>
				  </ng-container> -->
            <ng-template #noNotifications>
              <div
                class="no-notifications-container"
              >
                <li
                  class="flex flex-column justify-center items-center py-3 px-2 my-1"
                  [style.background-color]='currentTheme === "dark" ? "#222831" : "white"'
                >
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="120"
                      height="120"
                      viewBox="0 0 512 512"
                      id="no-notification"
                    >
                      <g>
                        <path
                          fill="none"
                          d="M416 512H96a96 96 0 0 1-96-96V96A96 96 0 0 1 96 0h320a96 96 0 0 1 96 96v320a96 96 0 0 1-96 96Zm0 0"
                        ></path>
                        <path
                          fill="#ffd200"
                          d="M256 384a40.052 40.052 0 0 0 39.184-32H216.8a40.082 40.082 0 0 0 39.2 32Zm0 0"
                        ></path>
                        <path
                          fill="#ffd200"
                          d="M356.031 308.4a71.451 71.451 0 0 1-25.375-54.672V224a74.721 74.721 0 0 0-64-73.809v-11.52a10.664 10.664 0 1 0-21.328 0v11.52a74.708 74.708 0 0 0-64 73.809v29.742a71.552 71.552 0 0 1-25.473 54.758A18.667 18.667 0 0 0 168 341.343h176a18.668 18.668 0 0 0 12.031-32.943Zm0 0"
                        ></path>
                        <path
                          fill="#ffe466"
                          d="M373.328 384a10.6 10.6 0 0 1-7.535-3.121L131.121 146.207a10.667 10.667 0 0 1 15.086-15.086l234.672 234.672A10.664 10.664 0 0 1 373.328 384Zm0 0"
                        ></path>
                      </g>
                    </svg>
                  </div>
                  <div 
                  [style.color]='currentTheme === "dark" ? "#ffffff" : "black"'
                  class="font-semibold mr-4 mt-2">
                    No notifications
                  </div>
                </li>
                <li
                  class="flex justify-center items-center py-3 px-2 my-1 rounded-lg"
                  [style.background-color]='currentTheme === "dark" ? "#222831" : "white"'
                >
                  <a
                    (click)="toggleDropdown()"
                    class="w-full text-center text-blue-500 font-semibold"
                    routerLink="/notifications"
                    >View All Notifications</a
                  >
                </li>
              </div>
            </ng-template>
          </ul>
          <span class="tooltip-text">Notifications</span>
        </div>
      </div>

      <c-dropdown
        [popperOptions]="{ placement: 'bottom-start' }"
        variant="nav-item"
      >
        <button [caret]="false" cDropdownToggle class="py-0">
          <div class="tooltip-container">
            <a cNavLink class="mt-[2px]">
              <img
                class="help-image w-[21px] h-[21px]"
                [ngClass]="{
                  'dark-theme': isDarkTheme,
                  'light-theme': !isDarkTheme
                }"
                src="../../../../assets/images/question-mark.svg"
                alt="Quesstion mark"
                width="21"
                height="21"
              />
            </a>
            <span class="tooltip-text">Help Section</span>
          </div>
        </button>
        <ul cDropdownMenu class="pt-0 w-auto">
          <li>
            <h6
              cDropdownHeader
              class="bg-body-secondary text-body-secondary fw-semibold py-2"
            >
              Help Section
            </h6>
          </li>
          <li></li>
          <li>
            <a
              cDropdownItem
              href="https://support.genailia.com/portal/en/home"
              target="_blank"
            >
              <svg cIcon class="me-2" name="cilUser"></svg>
              Support
            </a>
          </li>
          <li>
            <a
              cDropdownItem
              href="https://support.genailia.com/portal/en/newticket"
              target="_blank"
            >
              <svg cIcon class="me-2" name="cilCreditCard"></svg> Report Issue
            </a>
          </li>
        </ul>
      </c-dropdown>
    </c-header-nav>
    <form [formGroup]="appFeedbackForm">
      <div
        *ngIf=" showAppFeedbackModal"
        class="fixed top-0 left-0  w-full h-full bg-opacity-70 bg-gray-900 flex justify-center items-center z-50 bg-gray-300/70 dark:bg-gray-600/70 text-white"
      >
        <div
          class="{{
            themes
              ? 'bg-gray-900 text-white rounded-lg shadow-lg p-8 sm:w-auto w-[80%]'
              : 'bg-white text-black rounded-lg shadow-lg p-8 sm:w-auto w-[80%]'
          }}"
        >
          <h2 class="text-2xl mb-4">Do you like Genailia ?</h2>
          <div class="star-rating flex items-center py-2">
            <span
              *ngFor="let star of stars; let i = index"
              class="p-2"
              (click)="onStarClick(i + 1)"
            >
              <i
                class="fa"
                [ngClass]="{
                  'fa-star': i < selectedRating,
                  'fa-star-o': i >= selectedRating
                }"
              ></i>
            </span>
          </div>

          <div class="mb-8">
            <input
              type="text"
              placeholder="Enter your feedback"
              formControlName="appFeedback"
              [(ngModel)]="appFeedback"
              class="{{
                themes
                  ? 'w-full px-3 py-2 border rounded-lg bg-gray-800 focus:border-white focus:ring-white'
                  : 'w-full px-3 py-2 border rounded-lg bg-white focus:border-white focus:ring-black'
              }}"
            />
          </div>
          <div class="mb-4 d-flex justify-between">
            <button
              type="button"
              (click)="submitAppFeedback()"
              class="w-48 bg-blue-500 text-white py-2 rounded-lg me-[1rem]"
            >
              Submit
            </button>
            <button
              type="button"
              (click)="closeAppFeedback()"
              class="w-48 bg-blue-500 text-white py-2 rounded-lg"
            >
              Close
            </button>
          </div>
          <!-- Response Message -->
          <div *ngIf="feedbackResponse" class="text-green-600 mb-4">
            {{ feedbackResponse }}
          </div>
        </div>
      </div>
    </form>

    <c-header-nav class="ms-0">
      <div class="nav-item py-1">
        <div
          [style.background-color]="isDarkTheme ? 'white' : 'black'"
          class="vr h-100 mx-2 text-body text-opacity-75"
        ></div>
      </div>
      <div class="tooltip-container">
        <ng-container *ngTemplateOutlet="themeDropdown" />
        <span class="tooltip-text">Themes</span>
      </div>
    </c-header-nav>

    <c-header-nav class="mx-0">
      <div class="nav-item py-1">
        <div
          [style.background-color]="isDarkTheme ? 'white' : 'black'"
          class="vr h-100 mx-2 text-body text-opacity-75"
        ></div>
      </div>
      <ng-container *ngTemplateOutlet="userDropdown" />
    </c-header-nav>
  </c-container>

  <c-container
    [fluid]="true"
    class="px-4 breadcrumb-router-C fs-08"
  >
    <c-breadcrumb-router />
  </c-container>
</ng-container>
<!--</c-header>-->

<ng-template #userDropdown>
  <c-dropdown
    [popperOptions]="{ placement: 'bottom-start' }"
    variant="nav-item"
  >
    <button [caret]="false" cDropdownToggle class="py-0 pe-0">
      <!-- <c-avatar shape="rounded-1" [size]="'md'"
			src="./assets/images/avatars/2.jpg" status="success"
			textColor="primary" /> -->
      <div class="tooltip-container top-1">
        <svg cIcon name="cilSmile" size="normal"></svg>
        <span class="tooltip-text">Profile</span>
      </div>
    </button>
    <ul cDropdownMenu class="pt-0 w-auto">
      <li>
        <p
        cDropdownHeader
          class="bg-body-primary text-body-secondary fw-semibold pt-2 pb-0 px-1"
        >
        <span class="flex gap-2 text-sm justify-center items-center">
          <svg style="enable-background:new 0 0 24 24;" width="20px" height="20px" version="1.1" viewBox="0 0 24 24" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="info"/><g id="icons"><g id="user"><ellipse cx="12" cy="8" rx="5" ry="6"/><path d="M21.8,19.1c-0.9-1.8-2.6-3.3-4.8-4.2c-0.6-0.2-1.3-0.2-1.8,0.1c-1,0.6-2,0.9-3.2,0.9s-2.2-0.3-3.2-0.9    C8.3,14.8,7.6,14.7,7,15c-2.2,0.9-3.9,2.4-4.8,4.2C1.5,20.5,2.6,22,4.1,22h15.8C21.4,22,22.5,20.5,21.8,19.1z"/></g></g></svg>
    
    <p class="text-ellipsis overflow-hidden ...">

      {{email}}
      
    </p>
        </span>
  
      </p>
      </li>
      <li>
        <hr cDropdownDivider />
      </li> 
      <li>
        <h6
          cDropdownHeader
          class="bg-body-secondary text-body-secondary fw-semibold py-2"
        >
          Account Settings
        </h6>
      </li>
      <li></li>
      <li>
        <a
          cDropdownItem
          href="https://login.genailia.com/realms/genzers/account/"
          target="_blank"
        >
          <svg cIcon class="me-2" name="cilUser"></svg>
          Profile
        </a>
      </li>
      <li>
        <a
          cDropdownItem
          href="https://billing.genailia.com/portal/genailia"
          target="_blank"
        >
          <svg cIcon class="me-2" name="cilCreditCard"></svg> Payments
        </a>
      </li>
      <li>
        <a
          cDropdownItem
          (click)="
            commonServices.navigateTo('/subscribe/purchase-subscription', false)
          "
        >
          <svg cIcon class="me-2" name="cilBookmark"></svg> Subscribe
        </a>
      </li>
      <li>
        <a
          cDropdownItem
          (click)="commonServices.navigateTo('/usage', false)"
          style="display: flex !important"
        >
          <svg
            fill="none"
            height="16"
            viewBox="0 0 20 20"
            width="16"
            class="me-2 w-[20px] h-[20px] flex justify-center items-center"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 15H9.986C9.75866 15.3 9.58564 15.6385 9.47564 16H4C2.89543 16 2 15.1046 2 14V4C2 2.89543 2.89543 2 4 2H14C15.1046 2 16 2.89543 16 4V9.23205C15.6742 9.37179 15.369 9.57466 15.103 9.84065L15 9.94363V4C15 3.44772 14.5523 3 14 3H4C3.44772 3 3 3.44772 3 4V14C3 14.5523 3.44772 15 4 15ZM12 5.5C12 5.22386 12.2239 5 12.5 5C12.7761 5 13 5.22386 13 5.5V11.9436L12.1194 12.8243C12.0449 12.737 12 12.6237 12 12.5V5.5ZM5 7.5C5 7.22386 5.22386 7 5.5 7C5.77614 7 6 7.22386 6 7.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5V7.5ZM9 9C8.72386 9 8.5 9.22386 8.5 9.5V12.5C8.5 12.7761 8.72386 13 9 13C9.27614 13 9.5 12.7761 9.5 12.5V9.5C9.5 9.22386 9.27614 9 9 9ZM10.9807 15.3772L15.8102 10.5478C16.5405 9.81741 17.7246 9.81741 18.455 10.5478C19.1853 11.2781 19.1853 12.4622 18.455 13.1926L13.6256 18.022C13.344 18.3036 12.9912 18.5033 12.6048 18.5999L11.1069 18.9744C10.4555 19.1372 9.86549 18.5472 10.0283 17.8958L10.4028 16.3979C10.4994 16.0116 10.6992 15.6588 10.9807 15.3772Z"
              fill="#212121"
            />
          </svg>

          Usage
        </a>
      </li>

      <li>
        <a
          cDropdownItem
          (click)="commonServices.navigateTo('/transactions', false)"
          style="display: flex !important"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xmlns:serif="http://www.serif.com/"
            width="14"
            height="14"
            viewBox="0 0 64 64"
            version="1.1"
            xml:space="preserve"
            class="me-2 w-[18px] h-[20px] flex justify-center items-center"

            style="
              fill-rule: evenodd;
              clip-rule: evenodd;
              stroke-linejoin: round;
              stroke-miterlimit: 2;
            "
          >
            <g>
              <path
                d="M3,8L3,61C3,62.105 3.895,63 5,63L59,63C60.105,63 61,62.105 61,61L61,8C61,6.895 60.105,6 59,6L54,6L54,3C54,1.896 53.104,1 52,1C50.896,1 50,1.896 50,3L50,6L44,6L44,3C44,1.896 43.104,1 42,1C40.896,1 40,1.896 40,3L40,6L34,6L34,3C34,1.896 33.104,1 32,1C30.896,1 30,1.896 30,3L30,6L24,6L24,3C24,1.896 23.104,1 22,1C20.896,1 20,1.896 20,3L20,6L14,6L14,3C14,1.896 13.104,1 12,1C10.896,1 10,1.896 10,3L10,6L5,6C3.895,6 3,6.895 3,8ZM57,20L7,20L7,59L57,59L57,20ZM57,16L57,10L54,10L54,12C54,13.104 53.104,14 52,14C50.896,14 50,13.104 50,12L50,10L44,10L44,12C44,13.104 43.104,14 42,14C40.896,14 40,13.104 40,12L40,10L34,10L34,12C34,13.104 33.104,14 32,14C30.896,14 30,13.104 30,12L30,10L24,10L24,12C24,13.104 23.104,14 22,14C20.896,14 20,13.104 20,12L20,10L14,10L14,12C14,13.104 13.104,14 12,14C10.896,14 10,13.104 10,12L10,10L7,10L7,16L57,16Z"
              />
              <g transform="matrix(1,0,0,1,-1,2)">
                <path
                  d="M15,28L21,28C22.104,28 23,27.104 23,26C23,24.896 22.104,24 21,24L15,24C13.896,24 13,24.896 13,26C13,27.104 13.896,28 15,28Z"
                />
              </g>
              <g transform="matrix(1,0,0,1,-1,10)">
                <path
                  d="M15,28L21,28C22.104,28 23,27.104 23,26C23,24.896 22.104,24 21,24L15,24C13.896,24 13,24.896 13,26C13,27.104 13.896,28 15,28Z"
                />
              </g>
              <g transform="matrix(1,0,0,1,-1,18)">
                <path
                  d="M15,28L21,28C22.104,28 23,27.104 23,26C23,24.896 22.104,24 21,24L15,24C13.896,24 13,24.896 13,26C13,27.104 13.896,28 15,28Z"
                />
              </g>
              <g transform="matrix(1,0,0,1,-1,26)">
                <path
                  d="M15,28L21,28C22.104,28 23,27.104 23,26C23,24.896 22.104,24 21,24L15,24C13.896,24 13,24.896 13,26C13,27.104 13.896,28 15,28Z"
                />
              </g>
              <g transform="matrix(1,0,0,1,14,2)">
                <path
                  d="M15,28L21,28C22.104,28 23,27.104 23,26C23,24.896 22.104,24 21,24L15,24C13.896,24 13,24.896 13,26C13,27.104 13.896,28 15,28Z"
                />
              </g>
              <g transform="matrix(1,0,0,1,14,10)">
                <path
                  d="M15,28L21,28C22.104,28 23,27.104 23,26C23,24.896 22.104,24 21,24L15,24C13.896,24 13,24.896 13,26C13,27.104 13.896,28 15,28Z"
                />
              </g>
              <g transform="matrix(1,0,0,1,14,18)">
                <path
                  d="M15,28L21,28C22.104,28 23,27.104 23,26C23,24.896 22.104,24 21,24L15,24C13.896,24 13,24.896 13,26C13,27.104 13.896,28 15,28Z"
                />
              </g>
              <g transform="matrix(1,0,0,1,14,26)">
                <path
                  d="M15,28L21,28C22.104,28 23,27.104 23,26C23,24.896 22.104,24 21,24L15,24C13.896,24 13,24.896 13,26C13,27.104 13.896,28 15,28Z"
                />
              </g>
              <g transform="matrix(1,0,0,1,29,2)">
                <path
                  d="M15,28L21,28C22.104,28 23,27.104 23,26C23,24.896 22.104,24 21,24L15,24C13.896,24 13,24.896 13,26C13,27.104 13.896,28 15,28Z"
                />
              </g>
              <g transform="matrix(1,0,0,1,29,10)">
                <path
                  d="M15,28L21,28C22.104,28 23,27.104 23,26C23,24.896 22.104,24 21,24L15,24C13.896,24 13,24.896 13,26C13,27.104 13.896,28 15,28Z"
                />
              </g>
              <g transform="matrix(1,0,0,1,29,18)">
                <path
                  d="M15,28L21,28C22.104,28 23,27.104 23,26C23,24.896 22.104,24 21,24L15,24C13.896,24 13,24.896 13,26C13,27.104 13.896,28 15,28Z"
                />
              </g>
            </g>
          </svg>
          <!-- <svg
            fill="none"
            height="16"
            viewBox="0 0 20 20"
            width="16"
            class="me-2 w-[20px] h-[20px] flex justify-center items-center"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 15H9.986C9.75866 15.3 9.58564 15.6385 9.47564 16H4C2.89543 16 2 15.1046 2 14V4C2 2.89543 2.89543 2 4 2H14C15.1046 2 16 2.89543 16 4V9.23205C15.6742 9.37179 15.369 9.57466 15.103 9.84065L15 9.94363V4C15 3.44772 14.5523 3 14 3H4C3.44772 3 3 3.44772 3 4V14C3 14.5523 3.44772 15 4 15ZM12 5.5C12 5.22386 12.2239 5 12.5 5C12.7761 5 13 5.22386 13 5.5V11.9436L12.1194 12.8243C12.0449 12.737 12 12.6237 12 12.5V5.5ZM5 7.5C5 7.22386 5.22386 7 5.5 7C5.77614 7 6 7.22386 6 7.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5V7.5ZM9 9C8.72386 9 8.5 9.22386 8.5 9.5V12.5C8.5 12.7761 8.72386 13 9 13C9.27614 13 9.5 12.7761 9.5 12.5V9.5C9.5 9.22386 9.27614 9 9 9ZM10.9807 15.3772L15.8102 10.5478C16.5405 9.81741 17.7246 9.81741 18.455 10.5478C19.1853 11.2781 19.1853 12.4622 18.455 13.1926L13.6256 18.022C13.344 18.3036 12.9912 18.5033 12.6048 18.5999L11.1069 18.9744C10.4555 19.1372 9.86549 18.5472 10.0283 17.8958L10.4028 16.3979C10.4994 16.0116 10.6992 15.6588 10.9807 15.3772Z"
              fill="#212121"
            />
          </svg> -->

          Transactions
        </a>
      </li> 
      <li>
        <a
          cDropdownItem
          [routerLink]="['/access-to-api-keys']"
        >
          <svg cIcon class="me-2" name="cilCode"></svg>
          Api-Keys
        </a>
      </li>
      <li>
        <hr cDropdownDivider />
      </li>
      <li>
        <a cDropdownItem (click)="logout()">
          <svg cIcon class="me-2" name="cilAccountLogout"></svg> Logout
        </a>
      </li> 
    </ul>
  </c-dropdown>
</ng-template>

<ng-template #themeDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle>
      <svg cIcon [name]="icons()" size="normal"></svg>
    </button>
    <div cDropdownMenu>
      @for (mode of colorModes; track mode.name) {
      <button
        (click)="dummy(mode)"
        [active]="colorMode() === mode.name"
        [routerLink]="[]"
        cDropdownItem
        class="d-flex align-items-center"
      >
        <svg cIcon class="me-2" [name]="mode.icon" size="normal"></svg>
        {{ mode.text }}
      </button>
      }
    </div>
  </c-dropdown>
</ng-template>
